import CreatorStoreFront from 'components/CreatorStoreFront/CreatorStoreFront';
import { withCreatorStoreFrontProps } from 'viewModel/creatorStoreFront/withCreatorStoreFrontProps';
import { withCookie } from 'hocs/withCookie';

const ConnectedCreatorStoreFront = withCookie(withCreatorStoreFrontProps(CreatorStoreFront), 'current_country', 'US', '/creators/error');

export default ConnectedCreatorStoreFront;
